const vaginalBleeding = [
        {
        label:"Amount",
        controlType:"radio button",
        options:["Trace", "Smear", "Soaking", "Flooding"]
        },

        { 
        label:"Character:",
        controlType:"checkbox group",
        options:["Fresh blood", "Dark blood"],
        },
        
        {
        label:"Frequency",
        controlType:"radio button",
        options:["Every day", "Most days", "Every week or two", "Occasionally"]
        },

        { 
        label:"Present for several:",
        controlType:"radio button",
        options:["Days", "Weeks","Months","Years"]
        }
    
        ]

        export default vaginalBleeding
        
    
    
